import React, { useState, useEffect } from 'react';
import { Upload, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { formatCompanyLogoUrl, updateCompanyLogo } from "../../api/companyApi";

const PLACEHOLDER_LOGO_URL = 'https://storage.googleapis.com/finiat-web-static-resources/utility/placeholder-detailed.jpeg';

const CompanyLogo = ({ imgUrl, companyId, editable = false, onLogoUpdate, height=60 }) => {
  const [logoUrl, setLogoUrl] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [cacheKey, setCacheKey] = useState(Date.now());

  useEffect(() => {
    const url = imgUrl || formatCompanyLogoUrl(companyId);
    setLogoUrl(`${url}?t=${cacheKey}`);
  }, [imgUrl, companyId, cacheKey]);

  const refreshImage = () => {
    setCacheKey(Date.now());
  };

  const handleLogoUpload = async (info) => {
    if (info.file.status === 'uploading') {
      setIsUploading(true);
      return;
    }
    if (info.file.status === 'done') {
      try {
        const result = await updateCompanyLogo(companyId, info.file.originFileObj);
        setLogoUrl(`${result.logo_url}?t=${Date.now()}`);
        localStorage.setItem('companyLogoUrl', result.logo_url);
        if (onLogoUpdate) {
          onLogoUpdate(result.logo_url);
        }
        // Refresh the image after a short delay to allow for backend processing
        setTimeout(refreshImage, 2000);
      } catch (error) {
        console.error('Failed to update logo:', error);
      } finally {
        setIsUploading(false);
      }
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height }}>
      <Image
        src={logoUrl || `${PLACEHOLDER_LOGO_URL}?t=${cacheKey}`}
        alt="Company Logo"
        style={{
          objectFit: 'cover',
          width: '100%',
          height,
          borderRadius: '0',
          filter: 'grayscale(100%) brightness(300%) ',
        }}
        preview={false}
        fallback={PLACEHOLDER_LOGO_URL}
      />
      {editable && (
        <Upload
          accept="image/*"
          showUploadList={false}
          customRequest={({ file, onSuccess }) => {
            setTimeout(() => {
              onSuccess("ok");
            }, 0);
          }}
          onChange={handleLogoUpload}
        >
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              background: 'var(--light-grey)',
              borderRadius: '4px',
              padding: '8px',
              cursor: 'pointer',
            }}
          >
            {isUploading ? (
              <span className="ant-upload-loading-icon" />
            ) : (
              <UploadOutlined style={{ color: '#0033ff' }} />
            )}
          </div>
        </Upload>
      )}
    </div>
  );
};

export default CompanyLogo;